var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[(_vm.$isSinglePage)?[_c('router-view')]:[_c('app-navigation'),_c('v-main',[_c('div',{staticClass:"pa-12"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"10","offset-md":"1"}},[_c('router-view')],1)],1)],1)])],_c('snackbar')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }